// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';

// lodash
import { each } from 'lodash-es';
// CRUD
import { QueryResultsModel } from '../../_base/crud';

import { ContactRelationshipAgreementModel } from '../_models/contact-relationship-agreement.model';

// State
import { ContactRelationshipAgreementState } from '../_reducers/contact-relationship-agreement.reducers';

export const selectContactRelationshipAgreementState =
  createFeatureSelector<ContactRelationshipAgreementState>('contactRelationshipAgreements');

export const selectContactRelationshipAgreementsById = (contactRelationshipAgreementsId: number) =>
  createSelector(selectContactRelationshipAgreementState, (contactRelationshipAgreementState) => {
    return contactRelationshipAgreementState.entities[contactRelationshipAgreementsId];
  });

export const selectContactRelationshipAgreementsPageLoading = createSelector(
  selectContactRelationshipAgreementState,
  (contactRelationshipAgreementState) => contactRelationshipAgreementState.loading,
);

export const selectCurrentContactIdInStoreForContactRelationshipAgreements = createSelector(
  selectContactRelationshipAgreementState,
  (contactRelationshipAgreementState) => contactRelationshipAgreementState.contactId,
);

export const selectCRShowInitWaitingMessage = createSelector(
  selectContactRelationshipAgreementState,
  (contactRelationshipAgreementState) => contactRelationshipAgreementState.showInitWaitingMessage,
);

export const selectContactRelationshipAgreementsActionLoading = createSelector(
  selectContactRelationshipAgreementState,
  (contactRelationshipAgreementState) => contactRelationshipAgreementState.actionsloading,
);

export const selectContactRelationshipAgreementsInStore = createSelector(
  selectContactRelationshipAgreementState,
  (contactRelationshipAgreementState) => {
    const items: ContactRelationshipAgreementModel[] = [];
    each(contactRelationshipAgreementState.ids, (ele) => {
      const index: number = +ele;
      items.push(contactRelationshipAgreementState.entities[index]);
    });
    return new QueryResultsModel(items, contactRelationshipAgreementState.totalCount);
  },
);
